var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _vm.hasNewLeftNavEnabled
        ? _c(
            "new-main-header",
            {
              attrs: {
                "show-plc-button": !_vm.isFraud,
                "show-one-off-button": !_vm.isFraud,
              },
            },
            [_vm._v("\n    Customer History\n  ")]
          )
        : _c(
            "main-header",
            {
              attrs: {
                "show-plc-button": !_vm.isFraud,
                "show-one-off-button": !_vm.isFraud,
              },
            },
            [
              _c(
                "span",
                { attrs: { slot: "arrow-back" }, slot: "arrow-back" },
                [
                  _c(
                    "el-tooltip",
                    {
                      staticClass: "item",
                      attrs: {
                        effect: "dark",
                        content: "Back to Start Page",
                        placement: "bottom-start",
                      },
                    },
                    [
                      _c(
                        "router-link",
                        { attrs: { to: { name: "HomePage" } } },
                        [_c("i", { staticClass: "el-icon-back" })]
                      ),
                    ],
                    1
                  ),
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "span",
                { attrs: { slot: "page-title" }, slot: "page-title" },
                [_vm._v("Customer Requests")]
              ),
            ]
          ),
      _vm._v(" "),
      _c("main-content", [
        _c(
          "div",
          { attrs: { slot: "main-content" }, slot: "main-content" },
          [
            _c(
              "el-card",
              {
                staticStyle: { "border-radius": "8px 8px 0 0 !important" },
                attrs: { "body-style": "padding: 0px; margin: 0px;" },
              },
              [
                _c(
                  "div",
                  [
                    _c("div", { staticClass: "header-pane" }, [
                      _c("div", { staticClass: "requests-header" }, [
                        _vm._v("\n              Requests\n            "),
                      ]),
                      _vm._v(" "),
                      _c(
                        "div",
                        { staticClass: "custom-tabs" },
                        [
                          _c(
                            "el-tabs",
                            {
                              staticClass: "is-active",
                              on: {
                                change: function ($event) {
                                  return _vm.clearSearch()
                                },
                              },
                              model: {
                                value: _vm.activeName,
                                callback: function ($$v) {
                                  _vm.activeName = $$v
                                },
                                expression: "activeName",
                              },
                            },
                            [
                              _c("el-tab-pane", { attrs: { name: "orders" } }, [
                                _c(
                                  "span",
                                  { attrs: { slot: "label" }, slot: "label" },
                                  [
                                    _vm._v(
                                      "\n                    Orders\n                  "
                                    ),
                                  ]
                                ),
                              ]),
                              _vm._v(" "),
                              _c(
                                "el-tab-pane",
                                { attrs: { name: "returns" } },
                                [
                                  _c(
                                    "span",
                                    { attrs: { slot: "label" }, slot: "label" },
                                    [_vm._v("\n                    Returns")]
                                  ),
                                ]
                              ),
                              _vm._v(" "),
                              _c(
                                "el-tab-pane",
                                {
                                  attrs: { name: "replacements", disabled: "" },
                                },
                                [
                                  _c(
                                    "span",
                                    { attrs: { slot: "label" }, slot: "label" },
                                    [
                                      _vm._v(
                                        "\n                    Replacements\n                  "
                                      ),
                                    ]
                                  ),
                                ]
                              ),
                              _vm._v(" "),
                              _c(
                                "el-tab-pane",
                                {
                                  attrs: {
                                    name: "send_parts/one_off",
                                    disabled: "",
                                  },
                                },
                                [
                                  _c(
                                    "span",
                                    { attrs: { slot: "label" }, slot: "label" },
                                    [
                                      _vm._v(
                                        "\n                    Send Parts/One-off\n                  "
                                      ),
                                    ]
                                  ),
                                ]
                              ),
                            ],
                            1
                          ),
                        ],
                        1
                      ),
                    ]),
                    _vm._v(" "),
                    _c(
                      "div",
                      {
                        staticClass: "search-box",
                        attrs: { id: "search-div" },
                      },
                      [
                        _c("el-input", {
                          staticClass: "search-box-body",
                          attrs: {
                            type: "text",
                            placeholder:
                              "Search by order ID, date or Ring device...",
                          },
                          model: {
                            value: _vm.searchInput,
                            callback: function ($$v) {
                              _vm.searchInput = $$v
                            },
                            expression: "searchInput",
                          },
                        }),
                      ],
                      1
                    ),
                    _vm._v(" "),
                    _vm.activeName == "orders"
                      ? _c("OrderTable", {
                          attrs: { "search-value": _vm.searchInput },
                          on: { "current-order": _vm.setCurrentOrder },
                        })
                      : _vm._e(),
                    _vm._v(" "),
                    _vm.activeName == "returns"
                      ? _c("ReturnTable", {
                          attrs: { "search-value": _vm.searchInput },
                        })
                      : _vm._e(),
                  ],
                  1
                ),
              ]
            ),
          ],
          1
        ),
      ]),
      _vm._v(" "),
      _vm.detailsVisible
        ? _c("OrderDetails", {
            attrs: {
              visible: _vm.detailsVisible,
              "order-number": _vm.currentOrder,
            },
            on: {
              "update:visible": function ($event) {
                _vm.detailsVisible = $event
              },
              "change-active": _vm.changeActiveTab,
            },
          })
        : _vm._e(),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }